import React, { PropsWithChildren, useEffect, useState } from "react";
import { Dropdown } from 'antd';

//Internal Components
import './MenuHeader.css';
import { useAuth } from "../../../contexts/auth";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Header } from "antd/lib/layout/layout";
import Configuration from "../../pages/Configuration/Configuration";
import Modal from "../Modal/Modal";
import ConfirmationModal from "../Modal/CorfimationModal";
import { getError, openNotification, tryCatch } from "../../constants/Utilities";
import { useLocation, useNavigate } from "react-router-dom";

interface IProp {
    currentPage: string;
    nameForm?: string;
    clientCode?: string;
    isMenu: boolean;

}


const MenuHeader: React.FC<IProp> = ({ currentPage, isMenu, nameForm, clientCode }) => {

    // States Context
    const { menuCollapsed, menuFixed, setMenuCollapsed, setMenuFixed, userInformation, signOut } = useAuth();

    //states
    const [closeSessionLoading, setCloseSessionLoading] = useState<boolean>(false);
    const [visibleConf, setVisibleConf] = useState<boolean>(false);
    const [visibleClose, setVisibleClose] = useState<boolean>(false);
    const [askBeforeClosing, setAskBeforeClosing] = useState<boolean>(false);
    const navigate = useNavigate();
    const locationcurrent = useLocation();


    const ConfigurationOptions = (): JSX.Element => (
        <div className="menu_confCase">
            <div className="configOption" onClick={() => setVisibleConf(true)}>
                Configuracion
            </div>
            <div className="configOption" onClick={() => setVisibleClose(true)}>
                Cerrar Sesion
            </div>
        </div>
    );

    // Handles
    const handleSignOut = () => {
        const isLeavePage = JSON.parse(localStorage.getItem('IsLeave') || 'null');
        if (isLeavePage) {
            tryCatch(() => {
                setCloseSessionLoading(true);
                signOut()
                    .then((response) => {
                        openNotification('success', 'Sessión Cerrada', response);
                    })
                    .catch((error) => {
                        openNotification('error', 'Error', getError(error));
                    })
                    .finally(() => {
                        setCloseSessionLoading(false);
                    })
            })
        }
        else {
            openNotification('error', 'Error', 'Para cerrar sesion es necesario que salga de la encuesta.');
        }
    }
    const ValidateCurrenLocation = () => {
        let NoSecuencialFormulario = "/EncuestaNoSequencial";
        let secuencialFormulario = "/SequentialSurvey";
        let validacion = locationcurrent.pathname === NoSecuencialFormulario || locationcurrent.pathname === secuencialFormulario;
        validacion ? localStorage.setItem('GoBackConfirmed', JSON.stringify(true)) : localStorage.setItem('GoBackConfirmed', JSON.stringify(false));
        navigate(-1);

    }
    return (
        <div className="container_header">

            <Header className="menu_header1">
                {isMenu === true ?
                    <div className="menu_collapsedIcon" onClick={() => { setMenuCollapsed(!menuCollapsed); setMenuFixed(!menuFixed) }}>
                        {menuCollapsed ? <MenuUnfoldOutlined className='trigger' /> : <MenuFoldOutlined className='trigger' />}
                        <div className="menu_currentPage">{currentPage}</div>
                    </div>
                    :
                    <div className="menu_collapsedIcon" >
                        <i className="fa-solid fa-angle-left icon-back" onClick={() => ValidateCurrenLocation()}></i>
                        <div className="menu_currentPage">
                            {!!nameForm && <h4>{nameForm}</h4>}
                            {!!currentPage && <h3>{currentPage}</h3>}
                            {!!clientCode && <h5>{clientCode}</h5>}</div>
                    </div>
                }


                <Dropdown trigger={['hover']} overlay={<ConfigurationOptions />} placement="bottom">
                    <div className="menu_user">
                        <div className="name">{userInformation?.primerNombre} {userInformation?.primerApellido}</div>
                        <div className="figure">
                            {!!userInformation?.fotoPerfil
                                ? <img className="photo" src={userInformation!.fotoPerfil!} />
                                : <i className="fa-solid fa-user default_photo"></i>
                            }
                        </div>
                    </div>
                </Dropdown>
            </Header>
            <Modal props={{ style: { top: '-10px' } }} title="Configuración" visible={visibleConf} setVisible={setVisibleConf} askBeforeClose={askBeforeClosing}>
                <Configuration setVisibleConf={setVisibleConf} setAskBeforeClosing={setAskBeforeClosing} />
            </Modal>
            <ConfirmationModal
                visible={visibleClose}
                setVisible={setVisibleClose}
                question="¿Deseas cerrar la sesión?"
                method={handleSignOut}
                loading={closeSessionLoading}
            />
        </div>
    )
}

export default MenuHeader;